import React from 'react';

interface DateFieldProps {
  id: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const sanitizeDateValue = (rawDate: string | undefined | null): string => {
  if (!rawDate) return '';

  const match = rawDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return '';

  const [_, year, month, day] = match;
  const yearNum = parseInt(year, 10);
  if (yearNum < 1900) return '';

  return `${year}-${month}-${day}`;
};

const DateField: React.FC<DateFieldProps> = ({
  id,
  value,
  onChange,
  disabled,
}) => {
  const safeDate = sanitizeDateValue(value);

  return (
    <input
      type="date"
      id={id}
      value={safeDate}
      onChange={onChange}
      className="h-10 w-full rounded border border-slate-200 px-4 text-sm text-slate-500 
        dark:border-slate-600 dark:bg-slate-800 dark:text-slate-300 outline-none transition-all 
        focus:border-blue-900 dark:focus:border-slate-400 disabled:cursor-not-allowed"
      disabled={disabled}
    />
  );
};

export default DateField;
